<template>
  <div><slot></slot></div>
</template>

<script>
export default {
  name: 'NoLayout.vue'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/NoLayout.vue